import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LEGAL_ROUTES } from "../constants/legal";
import "./CookieBanner.css";

const LANGUAGE_KEY = "zedro_academy_language";

const getInitialLanguage = () => {
  if (typeof window === "undefined") return "es";
  return localStorage.getItem(LANGUAGE_KEY) || "es";
};

const copy = {
  es: {
    aria: "Aviso de cookies",
    title: "Cookies en ZEDRO",
    textStart:
      "Usamos cookies esenciales para que el sitio funcione y, con tu permiso, cookies para analítica y personalización. Puedes aceptarlas, rechazarlas o configurar tus preferencias. Consulta nuestra",
    link: "Política de cookies",
    accept: "Aceptar",
    reject: "Rechazar",
    settings: "Configurar",
  },
  fr: {
    aria: "Avis sur les cookies",
    title: "Cookies sur ZEDRO",
    textStart:
      "Nous utilisons des cookies essentiels au fonctionnement du site et, avec votre autorisation, des cookies d’analyse et de personnalisation. Vous pouvez les accepter, les refuser ou configurer vos préférences. Consultez notre",
    link: "Politique de cookies",
    accept: "Accepter",
    reject: "Refuser",
    settings: "Configurer",
  },
};

export default function CookieBanner({ onOpenSettings }) {
  const [visible, setVisible] = useState(false);
  const [language, setLanguage] = useState(getInitialLanguage);

  const t = copy[language] || copy.es;

  useEffect(() => {
    const stored = localStorage.getItem("cookieConsent");
    if (!stored) setVisible(true);
  }, []);

  useEffect(() => {
    const syncLanguage = (event) => {
      const nextLanguage =
        event?.detail?.language ||
        localStorage.getItem(LANGUAGE_KEY) ||
        "es";

      setLanguage(nextLanguage);
    };

    window.addEventListener("zedro:languagechange", syncLanguage);
    window.addEventListener("storage", syncLanguage);

    return () => {
      window.removeEventListener("zedro:languagechange", syncLanguage);
      window.removeEventListener("storage", syncLanguage);
    };
  }, []);

  const handleChoice = (choice) => {
    if (choice === "custom") {
      onOpenSettings?.();
      return;
    }

    const record = {
      choice,
      ts: new Date().toISOString(),
      prefs:
        choice === "all"
          ? { essential: true, analytics: true, marketing: true }
          : { essential: true, analytics: false, marketing: false },
    };

    localStorage.setItem("cookieConsent", JSON.stringify(record));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="cb-wrap"
      role="dialog"
      aria-live="polite"
      aria-label={t.aria}
    >
      <div className="cb-card">
        <div className="cb-content">
          <div className="cb-title">{t.title}</div>

          <p className="cb-text">
            {t.textStart}{" "}
            <Link
              className="cb-link"
              to={LEGAL_ROUTES.cookies}
              state={{ from: "public" }}
            >
              {t.link}
            </Link>
            .
          </p>
        </div>

        <div className="cb-actions">
          <button
            type="button"
            className="cb-btn cb-btn--primary"
            onClick={() => handleChoice("all")}
          >
            {t.accept}
          </button>

          <button
            type="button"
            className="cb-btn cb-btn--secondary"
            onClick={() => handleChoice("reject")}
          >
            {t.reject}
          </button>

          <button
            type="button"
            className="cb-btn cb-btn--ghost"
            onClick={() => handleChoice("custom")}
          >
            {t.settings}
          </button>
        </div>
      </div>
    </div>
  );
}